import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import PriceOverrideDetailsListView from 'src/pages/orders/components/orderDetails/priceOverride/priceOverrideDetails/priceOverrideDetailsListVIew/PriceOverrideDetailsListView';
import PriceOverrideDetailsCardView from 'src/pages/orders/components/orderDetails/priceOverride/priceOverrideDetails/priceOverrideDetailsCardView/PriceOverrideDetailsCardView';
import { MobileView, DesktopView } from 'src/pages/orders/index';
import { getDisplayDate, getTimeZoneName } from 'src/utils/dateUtils';
import {
    PricingComments,
    PricingCommentsContainer,
    CommentsContainer,
    PricingMore,
} from './PriceOverrideDetails.styled';
import { useTranslation } from 'react-i18next';
import { convertTime24To12, isMobileDevice } from 'src/utils/util';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const PriceOverrideDetails = ({ handleSetItemClick, ordersList }) => {
    const [expand, setExpand] = useState(true);
    const [comments, setComments] = useState([]);
    const [tissue, setTissue] = useState([]);
    const [nonTissue, setNonTissue] = useState([]);
    const [nonBilled, setNonBilled] = useState([]);

    const { t } = useTranslation();

    const { priceOverrideOrderDetails, priceOverrideSummary } = useSelector(
        (state) => state.orderSummaryReducer?.priceOverride
    );

    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const orderType = orderBasicDetails?.currentOrderType;

    const { totalTissuePrice, totalNonTissuePrice } =
        priceOverrideSummary || {};

    const total =
        (totalTissuePrice ? totalTissuePrice : 0) +
        (totalNonTissuePrice ? totalNonTissuePrice : 0);

    const { pricingComments } = priceOverrideSummary || {};

    const isMobile = isMobileDevice();

    useEffectWithErrorLogging(() => {
        if (priceOverrideOrderDetails?.length > 0) {
            const tissueList = priceOverrideOrderDetails?.filter(
                (x) =>
                    x.salesOrg === 'S030' && !x.isAccountOwned && !x.isNotBilled
            );
            setTissue(tissueList);

            const nonTissueList = priceOverrideOrderDetails?.filter(
                (x) =>
                    x.salesOrg !== 'S030' && !x.isAccountOwned && !x.isNotBilled
            );
            setNonTissue(nonTissueList);

            const nonBilledList = priceOverrideOrderDetails?.filter(
                (x) => x.isAccountOwned || x.isNotBilled
            );
            setNonBilled(nonBilledList);
        }
    }, [priceOverrideOrderDetails]);

    // console.log(tissue);
    // console.log(nonTissue);
    // console.log(pricingComments);

    const CommentsExpandHandler = (index) => {
        const updateIndex = [...comments];
        const commentIndex = updateIndex.findIndex((x) => +x === +index);
        if (commentIndex >= 0) {
            updateIndex.splice(commentIndex);
        } else {
            updateIndex.push(index);
        }
        setComments(updateIndex);
    };

    return (
        <CollapsableCard
            id="orders-priceOverrideDetails-priceOverrideDetails-details"
            title={'Details'}
            onClick={() => setExpand(!expand)}
            isExpanded={expand}
            padding={'1rem'}
        >
            {expand ? (
                <>
                    {pricingComments && pricingComments?.length > 0 ? (
                        <>
                            <PricingComments
                                margin={'0 0 5px 0'}
                                fontColor={'#202124'}
                                fontFamily={'AvenirNextWorld Demi'}
                                letterSpacing={'0px'}
                            >
                                {t('orders.orderDetails.priceOverride.priceOverrideSummary.pricecomments')}
                            </PricingComments>
                            {pricingComments.map((comment, index) => {
                                const charLength = comment?.comments
                                    ? comment.comments.length
                                    : 0;
                                const cutoffCharLength = isMobile ? 110 : 120;
                                const showMore =
                                    charLength > cutoffCharLength
                                        ? true
                                        : false;
                                const isExpand =
                                    comments?.filter((x) => x === index)
                                        ?.length > 0
                                        ? true
                                        : false;
                                const text = comment?.comments
                                    ? showMore && !isExpand
                                        ? comment.comments
                                              .slice(0, cutoffCharLength)
                                              .concat('...')
                                        : comment.comments
                                    : null;

                                return (
                                    <PricingCommentsContainer
                                        margin={'0 0 5px 0'}
                                        key={index}
                                    >
                                        {comment?.date ||
                                        comment?.time ||
                                        comment?.timeZone ||
                                        comment?.firstName ||
                                        comment?.lastName ? (
                                            <PricingComments
                                                margin={'0 0 5px 0'}
                                            >
                                                {comment?.date
                                                    ? getDisplayDate(
                                                          new Date(
                                                              comment.date
                                                          )
                                                      )
                                                    : null}{' '}
                                                {comment?.time
                                                    ? convertTime24To12(
                                                          new Date(comment.time)
                                                      )
                                                    : null}{' '}
                                                {getTimeZoneName()}{' '}
                                                {comment?.firstName ||
                                                comment?.lastName ? (
                                                    <>
                                                        {t('orders.orderDetails.billingSummary.by')}{' '}
                                                        {comment?.firstName
                                                            ? comment.firstName
                                                            : null}{' '}
                                                        {comment?.lastName
                                                            ? comment.lastName
                                                            : null}
                                                    </>
                                                ) : null}
                                            </PricingComments>
                                        ) : null}
                                        {text ? (
                                            <CommentsContainer>
                                                <PricingComments
                                                    margin={'0 0 5px 0'}
                                                >
                                                    {`"${text}"`}
                                                    {showMore ? (
                                                        <PricingMore
                                                         id={`orders-priceoverride-details-comment-${index}-expand-collapse-more-text`}
                                                            onClick={() =>
                                                                CommentsExpandHandler(
                                                                    index
                                                                )
                                                            }
                                                        >
                                                            {isExpand
                                                                ? t('orders.orderDetails.billingSummary.less')
                                                                : t('common.moreLabel')}
                                                        </PricingMore>
                                                    ) : null}
                                                </PricingComments>
                                            </CommentsContainer>
                                        ) : null}
                                    </PricingCommentsContainer>
                                );
                            })}
                        </>
                    ) : null}
                    <DesktopView>
                        <PriceOverrideDetailsListView
                            tissue={tissue}
                            nonTissue={nonTissue}
                            totalTissuePrice={totalTissuePrice}
                            totalNonTissuePrice={totalNonTissuePrice}
                            handleSetItemClick={handleSetItemClick}
                            ordersList={ordersList}
                            nonBilledList={nonBilled}
                            orderType={orderType}
                            total={total}
                        />
                    </DesktopView>
                    <MobileView>
                        <PriceOverrideDetailsCardView
                            tissue={tissue}
                            nonTissue={nonTissue}
                            totalTissuePrice={totalTissuePrice}
                            totalNonTissuePrice={totalNonTissuePrice}
                            handleSetItemClick={handleSetItemClick}
                            ordersList={ordersList}
                            nonBilledList={nonBilled}
                            total={total}
                        />
                    </MobileView>
                </>
            ) : null}
        </CollapsableCard>
    );
};

export default PriceOverrideDetails;
